import router from '../router'
import $axios from 'axios';
import store from '../store';

export default {
    //全球一张图
    world1m2021:"https://tile.charmingglobe.com/tile/world2021/tms/{z}/{x}/{y}?v=v1&token=Bearer 8bdba212ae5398db7063ebe72366bca1",
    china1m2022:"https://tile.charmingglobe.com/tile/china2022/tms/{z}/{x}/{y}?v=v1&token=Bearer 027f6004c4efb4cc3bc409334e7481a3",
    china1m2023:"https://tile.charmingglobe.com/tile/china2023_5_shield/tms/{z}/{x}/{y}?v=v1&token=Bearer fdsa0c81f784490a4c5dfghdfgh",
    world1m2021_number:"GS吉（2023）010号",
    china1m2022_number:"GS吉（2023）011号",
    china1m2023_number:"GS（2024）3173号",

    tianditu:'https://t0.tianditu.gov.cn/DataServer?T=vec_w&X={x}&Y={y}&L={z}&tk=f5e247a85a4e7b9a605370d0f769d080',
    tianditu_number:"GS（2024）0568号",


    //图层访问域名（仅一处使用未修改图层前后缀，功能已作废，前端无入口）
    charmingglobeLayerUrl:"https://tile.charmingglobe.com/map/dataset/",

    mapboxToken:"",
    //不带阿里字体的样式，修改store中的font
    mapboxStyle:"https://earth.jl1.cn/symbolresourceEarth/cgwxOceanLandGray.json",
    //带阿里字体的样式，和mapbox账号绑定，修改store中的font
    // mapboxStyle:"https://earth.jl1.cn/symbolresource/cgwxOceanLandGrayFont.json",



    //app前端页面（长图文预览使用）
    appH5Url:"http://121.36.68.139:8080/",   //测试环境 http://121.36.68.139:8080/，正式环境 https://earth.jl1.cn/
    passwordRules:[
        v => /^(?=.*[~·！!@#￥$%…^&*（）()\-=—_+[{}【】、|\\；‘：“;’:”,./<>?。《》？-]).{6,16}$/.test(v)|| 'Name is required',
    ],


    //退出登录
    quitLogin(){
        window.localStorage.setItem('authorToken','')
        router.push({
            name: 'earthLogin',
        })

        //用户退出，标记文件信息清空
        if(store.state.initGlobeOperationMarker){
            store.state.initGlobeOperationMarker = false;
            store.state.currFolderId = "";
            store.state.currFolderName = "";
            store.state.currFolderPublicStatus = "";
        }

    },

    //清空图形验证码相关数据
    clearPicCaptchaData(){
        store.state.picCaptcha = "";
        store.state.picCaptchaError = false
    },


    //base64转file传后台
    base64ToFile(urlData, fileName) {
        let arr = urlData.split(',');
        let mime = arr[0].match(/:(.*?);/)[1];
        let bytes = atob(arr[1]); // 解码base64
        let n = bytes.length
        let ia = new Uint8Array(n);
        while (n--) {
            ia[n] = bytes.charCodeAt(n);
        }
        return new File([ia], fileName, { type: mime });
    },


    //上传base64图片到http
    base64ToHttp(url){
        return new Promise((resolve,reject)=>{
            console.log(reject)
            let file = this.base64ToFile(url,"base64image.jpg");
            let paramData = new FormData();
            paramData.append('multipartFile',file);
            $axios.post('/managerApi/upoladFile/uploadPiture',paramData)
                .then((resultData)=>{
                    resultData = resultData.data;
                    if(resultData.status === 200){
                        resolve(resultData.data.picture)
                    }
                    else{
                        console.log(resultData.status + resultData.message);
                    }
                })
                .catch(()=>{

                })
        })
    },

    //http图片路径转base64数据
    imageUrlToBase64(imageUrl) {
        return new Promise((resolve,reject)=>{
            console.log(reject)
            var xhr = new XMLHttpRequest();
            xhr.open("get", imageUrl, true);
            xhr.responseType = "blob";
            xhr.onload = function() {
                var blob = this.response;
                /* blob二进制 to base64 */
                blobToDataURI(blob, function (data) {
                    resolve(data)
                });
            }
            xhr.send();
        })

        /* blob二进制 to base64 */
        function blobToDataURI(blob, callback) {
            var reader = new FileReader();
            reader.onload = function (e) {
                callback(e.target.result);
            }
            reader.readAsDataURL(blob);
        }

    },


    //影像集收藏/取消收藏
    //like：收藏为1，取消收藏为0
    likeOrCancelLikeImageLib(mainId,like,callback){
        $axios({
            method:"get",
            url:"/authorApi/z-user-collect/userCollect",
            params:{
                mainId:mainId,
                type:like
            }
        }).then((resultData)=>{
            resultData = resultData.data;
            if(resultData.status === 200){
                callback();
            }
            else{
                console.log(resultData.status + resultData.message);
            }
        }).catch((err)=>{
            console.log(err);
        });

    },

    //影像集复制分享链接
    shareImageLib(mainId,title,callback){
        let text = "【吉林一号·共生地球-遥感影像集-" + title + "】" + window.location.origin + "/creator/productDetails?mainId="+mainId;
        if (!navigator.clipboard) {
            //浏览器还没有支持navigator.clipboard，使用旧方法

            // 1.创建一个可选中元素
            let textArea = document.createElement("textarea");
            textArea.value = text;
            // 2.使用定位，阻止页面滚动
            textArea.style.top = "0";
            textArea.style.left = "0";
            textArea.style.position = "fixed";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                var successful = document.execCommand('copy');
                if(successful){
                    callback()
                }
            } catch (err) {
                console.error('Fallback: Oops, unable to copy', err);
            }
            // 3.移除元素
            document.body.removeChild(textArea);

            return;
        }
        //浏览器支持navigator.clipboard
        navigator.clipboard.writeText(text).then(function() {
            callback()
        }, function(err) {
            console.error('Async: Could not copy text: ', err);
        });
    },



    //影像集类别序号转为对应文字
    imageTypeToString(typeVal,callback){
        $axios({
            method:"get",
            url:"/authorApi/z-image-collection-type/getList",
        }).then((resultData)=>{
            resultData = resultData.data;
            if(resultData.status === 200){
                //类别
                for(let i=0;i<resultData.data.length;i++){
                    if(resultData.data[i].typeId === typeVal){
                        callback(resultData.data[i].typeName)
                        break;
                    }
                }
            }
            else{
                console.log(resultData.status + resultData.message);
            }
        }).catch((err)=>{
            console.log(err);
        });
    },



    //标记文件解析成树状列表，内部不包含行政区域（标记导出，录制添加素材）
    markerFolderDeleteAutonomousRegion(treeList,newTreeList) {
        for(let i=0;i<treeList.length;i++){
            if(treeList[i].type === "folder" && treeList[i].children &&  treeList[i].children.length>0){
                //是目录 同时有孩子
                let tempData=JSON.parse(JSON.stringify(treeList[i]))
                tempData.children=[]
                this.markerFolderDeleteAutonomousRegion(treeList[i].children,tempData.children)
                newTreeList.push(tempData)
            }
            else if(treeList[i].type !== "folder"){
                //是标记
                if(treeList[i].type !== "administrativeArea"){
                    //非行政区
                    let tempData=JSON.parse(JSON.stringify(treeList[i]))
                    newTreeList.push(tempData)
                }
            }
            else{
                //是目录，但是没有孩子

            }

        }

        //孩子都没选中的目录 移除
        for(let i=newTreeList.length - 1;i >= 0;i--){
            if(newTreeList[i].type === "folder" && newTreeList[i].children.length === 0){
                newTreeList.splice(i,1)
            }
        }

    },
    //根据标记的type获取树状列表中名称前图标
    getPrependIconByType(type){
        switch(type){
            case "point":{
                return "&#xe62d;"
            }
            case "lineString":{
                return "&#xe669;"
            }
            case "circle":{
                return "&#xe670;"
            }
            case "polygon":{
                return "&#xe668;"
            }
            case "rectangle":{
                return "&#xe66e;"
            }
            case "roadString":{
                return "&#xe661;"
            }
            case "administrativeArea":{
                return "&#xe663;"
            }


        }

    },
    //修改列表的缩进
    markerFolderChangeTreeviewLevel(treeDomId){
        let treeLevel2 = document.querySelector("#"+treeDomId).querySelectorAll(".v-treeview-node__level");

        for(let j=0;j<treeLevel2.length;j++){
            let nextBro_treeviewNodeContent = "";
            let broList = treeLevel2[j].parentNode.children
            for(let i=0;i<broList.length;i++){

                //获取该level后面的v-treeview-node__content兄弟，level需要移动到该兄弟之前
                //因为文件夹的前面隐藏了打开关闭按钮，所以非文件夹元素需要删除掉一个level保持对齐
                if(broList[i].getAttribute("class") === "v-treeview-node__content"){
                    nextBro_treeviewNodeContent = broList[i];

                    if(nextBro_treeviewNodeContent.querySelector(".v-treeview-node__prepend").querySelector("p").getAttribute("class").indexOf("prependIconFolder") === -1){
                        //不是文件夹，需要减少一个level
                        let nextBor = treeLevel2[j].nextElementSibling;
                        if(nextBor.getAttribute("class") === "v-treeview-node__level"){
                            //下一个兄弟仍然是level，移动该level到content元素之前
                            treeLevel2[j].parentNode.insertBefore(treeLevel2[j],nextBro_treeviewNodeContent)
                        }
                        else{
                            //是最后一个level，删除
                            treeLevel2[j].remove()
                        }
                    }
                    else{
                        //是文件夹，level移动到content元素之前
                        treeLevel2[j].parentNode.insertBefore(treeLevel2[j],nextBro_treeviewNodeContent)
                    }

                    break;
                }
            }

        }
    },
    //树的最外层修改成表头
    markerFolderChangeTreeviewHeader(treeDomId){
        let firstTreeviewNode = document.querySelector("#"+treeDomId).querySelector(".v-treeview-node");
        //第一个根节点，即表头
        let firstTreeviewNode_root = firstTreeviewNode.querySelector(".v-treeview-node__root")
        firstTreeviewNode_root.style.position = "fixed";
        firstTreeviewNode_root.style.width = "720px";
        firstTreeviewNode_root.style.zIndex = "1";
        firstTreeviewNode_root.style.background = "#ffffff";
        //第一个孩子区域，即除表头外的内容列表
        let firstTreeviewNode_children = firstTreeviewNode.querySelector(".v-treeview-node__children")
        firstTreeviewNode_children.style.paddingTop = "44px";
    },




    //工具——文件大小 字节转换成B KB MB GB，保留两位小数
    sizeToStr(size) {
        var data = "";
        if (size < 0.1 * 1024) { //如果小于0.1KB转化成B
            data = size.toFixed(2) + "B";
        } else if (size < 0.1 * 1024 * 1024) {//如果小于0.1MB转化成KB
            data = (size / 1024).toFixed(2) + "KB";
        } else if (size < 0.1 * 1024 * 1024 * 1024) { //如果小于0.1GB转化成MB
            data = (size / (1024 * 1024)).toFixed(2) + "MB";
        } else { //其他转化成GB
            data = (size / (1024 * 1024 * 1024)).toFixed(2) + "GB";
        }
        var sizestr = data + "";
        var len = sizestr.indexOf(".");
        var dec = sizestr.substr(len + 1, 2);
        if (dec == "00") {//当小数点后为00时 去掉小数部分
            return sizestr.substring(0, len) + sizestr.substr(len + 3, 2);
        }
        return sizestr;
    },

    //工具--获取唯一id
    async getNewId(fun){
        $axios.get('/authorApi/z-geo-file/getGeneratorId').then((res)=>{
            if(res.data.status === 200){
                fun(res.data.data);
            }
        })
    }



}
